import { useGetRoom, type RoomPriceInfoResponse } from "@/shared/server";
import { createDate } from "@/utils";
import { Center, Spinner } from "@chakra-ui/react";
import { useBookingRecoilValue, useNewNavigate } from "@shared/client";
import { DateHandler, PriceTable } from "./components";
import { CustomButton } from "./roomPrice.style";

export const RoomPrices = ({ roomIdx }: { roomIdx: string }) => {
    const { currentDateInfo } = createDate();
    const { data } = useGetRoom<RoomPriceInfoResponse>({
        section: "prices",
        roomIdx,
        date: currentDateInfo,
    });
    const { onNavigate } = useNewNavigate();
    const bookingEngine = useBookingRecoilValue();

    return data ? (
        <Center as="section" flexDir="column" rowGap="56px">
            <Center w="100%" flexDir="column" rowGap="32px">
                <DateHandler roomIdx={roomIdx} durationDate={data.durationDate} />
                <PriceTable currentPrices={data.currentPrices} />
            </Center>
            <CustomButton
                iconNamed="notifications"
                size="medium"
                border="none"
                onClick={() =>
                    bookingEngine.isGoogleBE ? window.open(bookingEngine.bookingUrl) : onNavigate({ path: "/reserve" })
                }
            >
                예약하기
            </CustomButton>
        </Center>
    ) : (
        <Spinner />
    );
};
